
import { Component, Vue } from "vue-property-decorator";
import * as Models from "@gigalot/data-models";
import { listVaccination } from "@/helpers/graphql-list-items";
import { getItemFromServer } from "@/helpers/get-item-from-server";

@Component
export default class VaccinationData extends Vue {
  vaccinations: { guid: string; description?: string; numDoses?: number }[] = [];
  searchTerm = "";
  detailsDialog = false;
  isLoadingDetails = false;
  details: Models.Vaccination | null = null;

  created() {
    this.$store.commit("navFuncs", {
      save: undefined,
      back: () => this.$router.go(-1),
    });
    this.loadVaccinations();
  }

  async loadVaccinations() {
    this.vaccinations = await listVaccination(true);
  }

  get filteredVaccinations() {
    const term = this.searchTerm.trim().toLowerCase();
    if (!term) return this.vaccinations;
    return this.vaccinations.filter((vaccination) => (vaccination.description || "").toLowerCase().includes(term));
  }

  async openVaccinationDetails(vaccination: { guid: string }) {
    this.details = null;
    this.detailsDialog = true;
    this.isLoadingDetails = true;
    try {
      this.details = await getItemFromServer("Vaccination", vaccination.guid);
    } finally {
      this.isLoadingDetails = false;
    }
  }

  closeVaccinationDetails() {
    this.detailsDialog = false;
    this.details = null;
  }

  doseKey(dose: Models.Dose, index: number): string | number {
    return (dose.item && dose.item.description) || index;
  }

  doseDescription(dose: Models.Dose, index: number): string {
    return (dose.item && dose.item.description) || `Dose ${index + 1}`;
  }

  formatDoseLabel(dose: Models.Dose): string {
    const amount = dose.amount !== undefined ? dose.amount : "";
    const unit = dose.unit || "cc";
    if (dose.type === "cc-mass-dependent") {
      const kgPerDose = dose.kgPerDose !== undefined ? dose.kgPerDose : "?";
      return unit === "each" ? `${amount} per ${kgPerDose} kg` : `${amount} ${unit} per ${kgPerDose} kg`;
    }
    return `${amount} ${unit}`;
  }
}
